import React, { useState } from "react";
import filtersearch from "assets/images/icon/filter-search.png";
import pluswhite from "assets/images/icon/plus-white.png";
import deleteicon from "assets/images/icon/delete-icon.png";
import { Modal, Button } from "react-bootstrap";
import Input from "components/Input";
import Select from "components/Select";

function AddTimeCard() {
    const [show, setShow] = useState(false);

    return (
        <div className='content' style={{ padding: "16px 24px 16px 16px" }}>
            <div className="payroll-section">
                {/* <div className='breadcrumb-section pb-3 border-bottom'>
                    <h2 className='main-title mb-1'>Payroll</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                            <li className="breadcrumb-item"><a href="#">Time & Attendance</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Add Time Card</li>
                        </ol>
                    </nav>
                </div> */}
                <div className='payroll-details-section mt-3'>
                    <div>
                        <h2 className='main-title'>Add Time Period</h2>
                        <h3 className='sub-title mb-3 mt-3'>Genral Information</h3>
                    </div>
                    <form>
                        <div className='row mb-3'>
                            <div className="col-lg-8">
                                <label>Search Employess</label>
                                <div className="search-input position-relative">
                                    {/* <input type='text' className='input-search w-100' placeholder='Search Employees'/> */}
                                    <Input variant='flat' fullWidth placeholder='Search Employees' />
                                    <img
                                        className="search-icon position-absolute"
                                        src={filtersearch}
                                        alt="filtersearch"
                                        style={{
                                            top: "14px",
                                            right: "10px"
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Search Workplaces</label>
                                <Select
                                    fullWidth
                                    placeholder="Search Workplaces"
                                    options={[]}
                                />
                            </div>
                            <div className="col-lg-8 mt-3">
                                <div className='row'>
                                    <h3 className='sub-title'>Clock-in/out Information</h3>
                                    <div className="col-lg-6 mt-3">
                                        <label>Clock-in Date*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='date'
                                        />
                                    </div>
                                    <div className="col-lg-6 mt-3">
                                        <label>Clock-in Time*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='time'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Clock-in Note</label>
                                <Input fullWidth variant='flat' placeholder='description' />
                            </div>
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-lg-6 mt-3">
                                        <label>Clock-in Date*</label>
                                        {/* <input className='w-100' type={"date"}/> */}
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='date'
                                        />
                                    </div>
                                    <div className="col-lg-6 mt-3">
                                        <label>Clock-in Time*</label>
                                        {/* <input className='w-100' type={"time"}/> */}
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='time'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Clock-in Note</label>
                                <Input fullWidth variant='flat' placeholder='description' />
                            </div>
                            <div className='col-lg-8 mt-3'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h3 className='sub-title mb-3 mt-3'>Breaks Information</h3>
                                    <button type='button' className='button-orange py-2 rounded-pill d-flex justify-content-center align-items-center gap-2'>
                                        <img src={pluswhite} alt="pluswhite" />
                                        Add Break</button>
                                </div>
                                <div className='d-flex align-items-center justify-content-between mt-3'>
                                    <h3 className='sub-title mb-3 mt-3'>Break 1</h3>
                                    <img className='' src={deleteicon} alt="deleteicon" />
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Break Type</label>
                                <Select
                                    fullWidth
                                    placeholder="Search Workplaces"
                                    options={[]}
                                />
                            </div>
                            <div className="col-lg-8 mt-3">
                                <div className='row'>
                                    <div className="col-lg-6">
                                        <label>Break Start Date*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='date'
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <label>Berak Start Time*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='time'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Break-start Now</label>
                                <Input fullWidth variant='flat' placeholder='description' />
                            </div>
                            <div className="col-lg-8 mt-3">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <label>Break End Date*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='date'
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <label>Berak End Time*</label>
                                        <Input
                                            variant='flat'
                                            fullWidth
                                            type='time'
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 mt-3">
                                <label>Break-End Now</label>
                                <Input fullWidth variant='flat' placeholder='description' />
                            </div>
                            <div className='mt-5 d-flex align-items-center gap-3'>
                                <button className='button-orange'>Add Timecard</button>
                                <button className='cancel-button'>Cancel</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}


export default AddTimeCard;
